import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  const { fill = "black" } = props;
  return (
    <Svg
      {...props}
      width={8}
      height={10}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M3.636 1.04a.662.662 0 00-.008.112v6.35l-.062-.139A1.288 1.288 0 003.316 7l-1.73-1.78a.634.634 0 00-.83-.094.656.656 0 00-.081.966l3.128 3.22c.245.252.64.252.885 0l3.13-3.22a.657.657 0 00-.063-.966.634.634 0 00-.83.094L5.193 6.996a1.287 1.287 0 00-.228.322l-.084.193V1.188a.663.663 0 00-.526-.68.628.628 0 00-.718.533z"
        fill={fill}
      />
    </Svg>
  );
}

export default SvgComponent;
